import AppNavLink from '@/components/Router/AppNavLink';
import { AppRoutes, buildRoute } from '@/route/routeConfig';

interface IPartnerProposalNavItems {
  name: 'Dashboard' | 'Partner Proposals';
  path: 'dashboard' | 'list';
}

const navPathToRouteKey: Record<IPartnerProposalNavItems['path'], AppRoutes> = {
  dashboard: AppRoutes.ROVER_PARTNER_PROPOSALS_DASHBOARD,
  list: AppRoutes.ROVER_PARTNER_PROPOSALS_LIST,
};

const partnerProposalNavItems: IPartnerProposalNavItems[] = [
  { name: 'Dashboard', path: 'dashboard' },
  { name: 'Partner Proposals', path: 'list' },
];

export default function PartnerProposalNav() {
  return (
    <div className='flex flex-col w-full'>
      <div className='border-b border-neutralColor-light  mb-5 flex gap-8'>
        {partnerProposalNavItems.map((item: IPartnerProposalNavItems) => (
          <AppNavLink
            key={item.path}
            to={buildRoute(navPathToRouteKey[item.path])}
            baseClassName='text-base m-0'
            activeClassName='border-primaryColor-normal text-primaryColor-normal border-b-2 pb-2'
          >
            {item.name}
          </AppNavLink>
        ))}
      </div>
    </div>
  );
}
